import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../models/index';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

@Injectable()
export class UserService {
	constructor(private http: HttpClient) { }

	private usernames: Array<string> = [];

	getUserName(id: number): Observable<string> {
		if(this.usernames[id]) {
			return Observable.of(this.usernames[id]);
		}

		return this.http.get<LoginResponse>('/api/v1/user/name/' + id).map(data => {
			this.usernames[id] = data.name;
			return data.name;
		});
	}
}

interface LoginResponse {
	name: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/services/user.service.ts